<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-10 11:02:09
-->
<template>
  <div>
    <div class="main colorlist">
      <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">新闻资讯</div>
        <div class="nav">
          <a
            :class="{ on: item.dictValue == tid }"
            v-for="(item, index) in navlist"
            @click="changetab(item.dictValue)"
            :key="index"
            >{{ item.dictName }}</a
          >
        </div>
      </div> 
    </div>-->
      <div class="nav">
        <div class="title">{{leftNavName}}</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div>
      <div class="content">
        <div class="search">
          <el-input
            placeholder="请输入关键字"
            clearable
            v-model="keyword"
            size="small"
            class="input-with-select"
          >
            <el-button
              slot="append"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div style="clear:both"></div>
        <!-- 循环navlist 对应显示内容 -->
        <div class="tabdiv">
          <!-- <div class="imgnewdiv" v-for="(item, index) in datalist" :key="index">
            <img :src="item.imgurl != null ? item.imgurl : noneimg" />
            <div class="namecon">
              <h2>{{ item.title }}</h2>
              <div class="ms" v-html="item.content"></div>
            </div>
            <div class="info">
              <p>{{ item.createDate ? item.createDate.split(" ")[0] : "" }}</p>
              <el-button type="danger" @click="toinfo(item.id)"
                >查看详情</el-button
              >
            </div>
          </div> -->
          <ul>
            <li
              style="cursor: pointer"
              v-for="(item, index) in datalist"
              @click="toinfo(item.id)"
              :key="index"
            >
              <p>
                {{ item.title }}
              </p>
              <span>{{ item.fbDate ? item.fbDate.split(" ")[0] : "" }}</span>
            </li>
          </ul>
        </div>

        <div class="pageno">
          <el-pagination
            background
            :current-page="pageno"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      tid: "",
      pageno: 1,
      navlist: [],
      total: 0,
      datalist: [],
      noneimg: require("@/assets/images/none.png"),
      leftNavName:''
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.pageno = this.$route.query.pageno - 0;
        this.keyword = this.$route.query.keyword || "";
        // 二级菜单时，获取companySummaryType
        var nav = JSON.parse(localStorage.getItem("nav"));
        this.leftNavName = nav.filter(item => {
          return item.parent.code === "websiteNews";
        })[0].parent.name;
        var navlist = nav.filter(item => {
          return item.parent.code === "websiteNews";
        })[0].child;
        this.navlist = navlist;
        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    search() {
      this.$router.push({
        path: "/news/news",
        query: { tid: this.tid, pageno: 1, keyword: this.keyword }
      });
    },
    getinfo() {
      this.$get(
        "/website/newsPage?menuCode=websiteNews&type=" +
          this.tid +
          "&limit=10&page=" +
          this.pageno +
          "&title=" +
          this.keyword
      ).then(res => {
        res.data.list.forEach(item => {
          item.content = item.content.replace(/<\/?(img)[^>]*>/gi, "");
        });
        this.datalist = res.data.list;

        this.total = res.data.total;
      });
    },
    toinfo(id) {
      this.$router.push({
        path: "/news/newsinfo",
        query: { tid: this.tid, id: id }
      });
    },
    handleCurrentChange(val) {
      // window.scrollTo(0, 0);
      this.$router.push({
        path: "/news/news",
        query: { tid: this.tid, pageno: val, keyword: this.keyword }
      });
    },
    changetab(index) {
      this.$router.push({
        path: "/news/news",
        query: { tid: index, pageno: 1 }
      });
    }
  }
};
</script>
<style scoped>
.search {
  width: 300px;
  padding-bottom: 20px;
  float: right;
}
.pageno {
  padding-top: 20px;
  text-align: right;
}

.tabdiv {
  position: relative;
}
.tabdiv > ul {
  width: 100%;
}
.tabdiv ul li {
  width: 100%;
  height: 60px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
}
.tabdiv ul li p {
  font-size: 15px;
}
.imgnewdiv {
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #ddd;
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
}
.imgnewdiv > img {
  height: 175px;
  width: 265px;
  float: left;
  border: 1px solid #efefef;
  box-sizing: border-box;
}
.imgnewdiv .namecon {
  float: left;
  /* width: 640px; */
  width: 380px;
  padding: 20px;
}
.imgnewdiv h2 {
  font-size: 18px;
  padding-bottom: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.imgnewdiv .ms {
  font-size: 16px;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-height: 90px;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.imgnewdiv .info {
  text-align: center;
  border-left: 1px solid #ddd;
  box-sizing: border-box;
  float: left;
  width: 230px;
  height: 175px;
}
.imgnewdiv .info p {
  padding: 40px 0 20px 0;
}
.imgnewdiv .info button {
  font-size: 16px;
  width: 160px;
}
.content {
  /* width: 1200px;
  margin: 0 auto;
  padding: 20px 0; */
  position: relative;
}
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
</style>
